import React, { useState } from "react";
import { RiCheckLine } from "react-icons/ri";
import './OrderTimeline.css';

const LABELS = {
    placed: "Placed",
    confirmed: "Confirmed",
    shipment_created: "Shipment Created",
    packed: "Order Packed",
    shipped: "Dispatched",
    out_for_delivery: "Out for Delivery",
    delivered: "Delivered",
    cancelled: "Order Cancelled",
    replacement_requested: "Replacement Requested",
    replacement_approved: "Replacement Approved",
    replacement_rejected: "Replacement Rejected",
    pickup_scheduled: "Pickup Scheduled",
    picked_up: "Picked Up",
    replacement_in_progress: "Replacement in Progress",
    replaced: "Replaced",
};

const REPLACEMENT_FLOW = [
    "replacement_requested",
    "replacement_approved",
    "pickup_scheduled",
    "picked_up",
    "replacement_in_progress",
    "replaced",
    "cancelled"
];

const OrderTimeline = ({ order }) => {
    const [showPopup, setShowPopup] = useState(false);

    const shouldShowExpectedDelivery =
        order.itemStatus !== "delivered" &&
        !REPLACEMENT_FLOW.includes(order.itemStatus);

    // Use statusHistory from backend, sorted by createdAt
    const steps = order.statusHistory
        .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
        .map((h) => ({
            key: h.status,
            label: LABELS[h.status] || h.status,
            completed: true,
            date: h.createdAt,
            remark: h.remark,
            changedByRole: h.changedByRole,
        }));

    // Current status is last item in history
    const currentStatus = steps.length > 0 ? steps[steps.length - 1].key : order.itemStatus;

    const formatDate = (date) => {
        if (!date) return "";
        return new Date(date).toLocaleDateString("en-IN", {
            day: "numeric",
            month: "short",
            year: "numeric",
        });
    };

    return (
        <div className="timeline-wrapper">

            {/* Header Status */}
            <h3 className="status-title">
                {currentStatus === "delivered"
                    ? `Delivered on ${formatDate(steps.find(s => s.key === "delivered")?.date)}`
                    : `Order Status: ${LABELS[currentStatus] || currentStatus}`}
            </h3>

            <div className="timeline">
                {steps.map((step) => (
                    <div
                        key={step.key}
                        className={`timeline-step completed ${step.key === currentStatus ? "active" : ""}`}
                    >
                        <div className="timeline-icon">
                            <RiCheckLine />
                        </div>

                        <div className="timeline-content">
                            <p className="step-title">{step.label}</p>
                            {step.date && (
                                <span className="step-date">{formatDate(step.date)}</span>
                            )}
                            {/* {step.remark && (
                                <span className="step-message">{step.remark}</span>
                            )} */}
                            {/* {step.changedByRole && (
                                <span className="step-role">By: {step.changedByRole}</span>
                            )} */}
                        </div>
                    </div>
                ))}
            </div>

            {/* See all updates popup */}
            <p className="view-all-updates" onClick={() => setShowPopup(true)}>
                See all updates →
            </p>

            {shouldShowExpectedDelivery && (
                <p>Expected Delivery: {formatDate(order.expectedDeliveryDate)}</p>
            )}

            {showPopup && (
                <div className="timeline-popup-overlay">
                    <div className="timeline-popup">
                        <div className="popup-header">
                            <h3>All Updates</h3>
                            <span onClick={() => setShowPopup(false)}>✕</span>
                        </div>
                        <div className="activity-timeline">
                            {steps.map((step) => (
                                <div key={step.key} className="activity-step">
                                    <div className="activity-dot"></div>
                                    <div className="activity-content">
                                        <p className="activity-title">
                                            {step.label}{" "}
                                            {/* {step.date && (
                                                <span className="activity-date">{formatDate(step.date)}</span>
                                            )} */}
                                        </p>
                                        {/* {step.remark && <p>{step.remark}</p>} */}
                                        <span className="activity-time">
                                            {step.date && new Date(step.date).toLocaleString("en-IN")}
                                        </span>
                                        {/* {step.changedByRole && <p>Changed by: {step.changedByRole}</p>} */}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default OrderTimeline;















// import React, { useState } from "react";

// import { RiCheckLine } from "react-icons/ri";

// import './OrderTimeline.css'


// const OrderTimeline = ({ order }) => {
//     const status = order.itemStatus;

//     const OrderItemStatus = {
//         ORDERED: "confirmed",
//         PACKED: "packed",
//         SHIPPED: "shipped",
//         OUT_FOR_DELIVERY: "out_for_delivery",
//         DELIVERED: "delivered",
//         CANCELLED: "cancelled",

//         REPLACEMENT_REQUESTED: "replacement_requested",
//         REPLACEMENT_APPROVED: "replacement_approved",
//         REPLACEMENT_REJECTED: "replacement_rejected",
//         PICKUP_SCHEDULED: "pickup_scheduled",
//         PICKED_UP: "picked_up",
//         REPLACEMENT_IN_PROGRESS: "replacement_in_progress",
//         REPLACED: "replaced",
//     };

//     // ✅ Status flows
//     const STATUS_FLOW = [
//         "confirmed",
//         "packed",
//         "shipped",
//         "out_for_delivery",
//         "delivered",
//     ];

//     const REPLACEMENT_FLOW = [
//         "replacement_requested",
//         "replacement_approved",
//         "pickup_scheduled",
//         "picked_up",
//         "replacement_in_progress",
//         "replaced",
//     ];

//     // ✅ Labels
//     const LABELS = {
//         confirmed: "Placed",
//         packed: "Order Packed",
//         shipped: "Dispatched",
//         out_for_delivery: "Out for Delivery",
//         delivered: "Delivered",

//         replacement_requested: "Replacement Requested",
//         replacement_approved: "Replacement Approved",
//         replacement_rejected: "Replacement Rejected",
//         pickup_scheduled: "Pickup Scheduled",
//         picked_up: "Picked Up",
//         replacement_in_progress: "Replacement in Progress",
//         replaced: "Replaced",

//         cancelled: "Order Cancelled",
//     };

//     const DATE_MAP = {
//         confirmed: order.createdAt,
//         packed: order.packedAt,
//         shipped: order.shippedAt,
//         out_for_delivery: order.outForDeliveryAt,
//         delivered: order.deliveredAt,

//         replacement_requested: order.replacementRequestedAt,
//         replacement_approved: order.replacementApprovedAt,
//         replacement_rejected: order.replacementRejectedAt,
//         pickup_scheduled: order.pickupScheduledAt,
//         picked_up: order.pickedUpAt,
//         replacement_in_progress: order.replacementInProgressAt,
//         replaced: order.replacementCompletedAt,

//         cancelled: order.cancelledAt,
//     };

//     // ✅ Flags
//     const isCancelled = status === "cancelled";
//     const isReplacementFlow = REPLACEMENT_FLOW.includes(status);
//     const isDelivered = status === "delivered";
//     const [showPopup, setShowPopup] = useState(false);

//     const formatDate = (date) => {
//         if (!date) return "";
//         return new Date(date).toLocaleDateString("en-IN", {
//             day: "numeric",
//             month: "short",
//             year: "numeric",
//         });
//     };

//     // ✅ Replacement steps logic
//     let steps = [];

//     if (isCancelled) {
//         steps = [
//             { key: "confirmed", completed: true },
//             { key: "cancelled", completed: true },
//         ];
//     } else if (isReplacementFlow) {
//         const replacementIndex = REPLACEMENT_FLOW.indexOf(status);

//         // Only show steps up to replacement_requested if not approved yet
//         if (status === "replacement_requested" || status === "replacement_rejected") {
//             steps = [
//                 { key: "delivered", completed: true },
//                 { key: "replacement_requested", completed: true },
//             ];
//         } else {
//             // Show full replacement flow if approved or in-progress
//             steps = [
//                 { key: "delivered", completed: true },
//                 ...REPLACEMENT_FLOW.map((step, index) => ({
//                     key: step,
//                     completed: index <= replacementIndex,
//                 })),
//             ];
//         }
//     } else {
//         const currentIndex = STATUS_FLOW.indexOf(status);

//         steps = STATUS_FLOW.map((step, index) => ({
//             key: step,
//             completed: index <= currentIndex,
//         }));
//     }

//     const currentMainIndex = STATUS_FLOW.indexOf(status);
//     const currentReplacementIndex = REPLACEMENT_FLOW.indexOf(status);

//     const fullReplacementSteps = [
//         ...STATUS_FLOW.map((step, index) => ({
//             key: step,
//             completed:
//                 currentMainIndex >= index || status === "delivered" || isReplacementFlow,
//         })),
//         ...REPLACEMENT_FLOW.map((step, index) => {
//             if (
//                 order.itemStatus === "replacement_requested" ||
//                 order.itemStatus === "replacement_rejected"
//             ) {
//                 return index === 0
//                     ? { key: step, completed: true }
//                     : null;
//             }
//             return { key: step, completed: index <= currentReplacementIndex };
//         }).filter(Boolean),
//     ];

//     return (
//         <div className="timeline-wrapper">

//             {/* ✅ Header Status */}
//             {status === "delivered" && (
//                 <h3 className="status-title">
//                     {`Delivered on ${formatDate(order.deliveredAt)}`}
//                 </h3>
//             )}

//             {status === "out_for_delivery" && (
//                 <h3 className="status-title">
//                     🚚 Out for delivery today
//                 </h3>
//             )}

//             {!isDelivered && status !== "out_for_delivery" && (
//                 <h3 className="status-title">
//                     {`Order Status: ${LABELS[status] || status}`}
//                 </h3>
//             )}

//             <div className="timeline">
//                 {steps.map((step) => {
//                     const isCurrentStep = step.key === status;

//                     return (
//                         <div
//                             key={step.key}
//                             className={`timeline-step
//                                 ${step.completed ? "completed" : "pending"}
//                                 ${isCurrentStep ? "active" : ""}
//                             `}
//                         >
//                             <div className="timeline-icon">
//                                 {step.completed ? <RiCheckLine /> : ""}
//                             </div>

//                             <div className="timeline-content">
//                                 <p className="step-title">
//                                     {LABELS[step.key]},
//                                 </p>

//                                 {DATE_MAP[step.key] && (
//                                     <span className="step-date">
//                                         {formatDate(DATE_MAP[step.key])}
//                                     </span>
//                                 )}

//                                 {!step.completed && (
//                                     <span className="step-message">
//                                         Pending
//                                     </span>
//                                 )}
//                             </div>
//                         </div>
//                     );
//                 })}

//                 {/* ✅ Cancel Block */}
//                 {isCancelled && (
//                     <div className="timeline-step cancelled">
//                         <div className="timeline-icon">✕</div>
//                         <div className="timeline-content">
//                             <p className="step-title">Order Cancelled</p>
//                             <span className="step-message">
//                                 This item was cancelled
//                             </span>
//                         </div>
//                     </div>
//                 )}
//             </div>

//             {/* {isReplacementFlow && ( */}
//             <p
//                 className="view-all-updates"
//                 onClick={() => setShowPopup(true)}
//             >
//                 See all updates →
//             </p>
//             {/* )} */}

//             {showPopup && (
//                 <div className="timeline-popup-overlay">
//                     <div className="timeline-popup">

//                         <div className="popup-header">
//                             <h3>All Updates</h3>
//                             <span onClick={() => setShowPopup(false)}>✕</span>
//                         </div>

//                         <div className="activity-timeline">

//                             {fullReplacementSteps.map((step, index) => (
//                                 <div key={step.key} className="activity-step">

//                                     {/* Left Dot */}
//                                     <div className="activity-dot"></div>

//                                     {/* Content */}
//                                     <div className="activity-content">

//                                         <p className="activity-title">
//                                             {LABELS[step.key]}{" "}
//                                             {DATE_MAP[step.key] && (
//                                                 <span className="activity-date">
//                                                     {formatDate(DATE_MAP[step.key])}
//                                                 </span>
//                                             )}
//                                         </p>

//                                         {/* Sub messages (simulate real tracking logs) */}
//                                         {DATE_MAP[step.key] && (
//                                             <div className="activity-sub">
//                                                 <p>Your item has been {LABELS[step.key].toLowerCase()}.</p>
//                                                 <span className="activity-time">
//                                                     {new Date(DATE_MAP[step.key]).toLocaleString("en-IN")}
//                                                 </span>
//                                             </div>
//                                         )}

//                                     </div>
//                                 </div>
//                             ))}

//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* ✅ Delivery / Return Info */}
//             <div className="delivery-info">
//                 {isDelivered ? (
//                     <p className="return-policy">
//                         Return policy ends on{" "}
//                         {formatDate(
//                             new Date(
//                                 new Date(order.deliveredAt).getTime() +
//                                 7 * 24 * 60 * 60 * 1000
//                             )
//                         )}
//                     </p>
//                 ) : (
//                     <p className="expected-delivery">
//                         Expected delivery: {formatDate(order.deliveredAt)}
//                     </p>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default OrderTimeline;